export const language = {
  EN: 'en',
  ES: 'es',
}
